import { useContext } from 'react';

import { TravelExpertContext } from 'context/TravelExpertContext';

import { travelExpertList as testingExpertList } from 'data/mocks/Incentive/TravelExpert/travelExpertList';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';
import { getURLParamValue } from 'utility/Provide/Url';

import { Environment } from 'types/legacy/backendInformation';

import { ChatBotData_ChatBotType } from 'proto/ChatBotData';
import { Salutation } from 'proto/User/Salutation';

export const useExpertList = () => {
    const { travelExpertList, chatBot } = useContext(TravelExpertContext);
    const { components } = useContext(CommunicationContext);
    const showExpert = getURLParamValue('showExpert') === '1';
    const deviceInformation =
        components.backendInformationFunc?.getDeviceInformation();
    const isTestingEnv =
        deviceInformation?.environment === Environment.Testing ||
        deviceInformation?.environment === Environment.Development;

    const expertList =
        showExpert && isTestingEnv ? testingExpertList : travelExpertList;

    const chatBotData =
        showExpert && isTestingEnv
            ? {
                  id: '1',
                  lastSeenCookieValue: '',
                  regionName: 'Test',
                  source: '',
                  lastName: 'Chatty',
                  salutation: Salutation.Female,
                  chatBotType: ChatBotData_ChatBotType.ChatBotTypeUnknown,
              }
            : chatBot;
    return {
        chatBot: chatBotData,
        expertList,
    };
};
